window.up = {
    version: '3.14.1'
};
